/**
 * Web端菜单配置数据（树形结构）
 * key 对应 WEB_MENU_IDS 常量名
 */
export const webMenuTree = [
  // 统计面板
  {
    key: "STATISTICS_PANEL",
    id: 10,
    name: "统计面板",
    code: "SYSTEM_STATISTICS-PANEL",
    sort: 1,
  },
  // 门店管理
  {
    key: "SHOP_MANAGE",
    id: 10002,
    name: "门店管理",
    code: "SHOP-MANAGE",
    sort: 2,
    children: [
      {
        key: "SHOP_MANAGE_SHOP",
        id: 1,
        name: "门店管理",
        code: "SYSTEM_SHOP-MANAGE",
        sort: 1,
        children: [
          {
            key: "SHOP_MANAGE_SHOP_SHOP",
            id: 10101,
            name: "门店管理",
            code: "SYSTEM_SHOP-MANAGE_SHOP",
            sort: 1,
            children: [
              {
                key: "SHOP_MANAGE_SHOP_ADD",
                id: 10104,
                name: "新增",
                code: "SYSTEM_SHOP-MANAGE_SHOP_ADD",
                sort: 1,
              },
              {
                key: "SHOP_MANAGE_SHOP_EDIT",
                id: 10105,
                name: "编辑",
                code: "SYSTEM_SHOP-MANAGE_SHOP_EDIT",
                sort: 2,
              },
              {
                key: "SHOP_MANAGE_SHOP_DELETE",
                id: 10106,
                name: "删除",
                code: "SYSTEM_SHOP-MANAGE_SHOP_DELETE",
                sort: 3,
              }
            ],
          },
          {
            key: "SHOP_MANAGE_SHOP_LEVEL",
            id: 10102,
            name: "等级管理",
            code: "SYSTEM_SHOP-MANAGE_LEVEL",
            sort: 2,
            children: [
              {
                key: "SHOP_MANAGE_LEVEL_ADD",
                id: 10107,
                name: "新增等级",
                code: "SYSTEM_SHOP-MANAGE_LEVEL_ADD",
                sort: 1,
              },
              {
                key: "SHOP_MANAGE_LEVEL_EDIT",
                id: 10108,
                name: "编辑等级",
                code: "SYSTEM_SHOP-MANAGE_LEVEL_EDIT",
                sort: 2,
              },
              {
                key: "SHOP_MANAGE_LEVEL_DELETE",
                id: 10109,
                name: "删除等级",
                code: "SYSTEM_SHOP-MANAGE_LEVEL_DELETE",
                sort: 3,
              },
              {
                key: "SHOP_MANAGE_LEVEL_COURSE",
                id: 10113,
                name: "类目管理",
                code: "SYSTEM_SHOP-MANAGE_COURSE",
                sort: 4,
                children: [
                  {
                    key: "SHOP_MANAGE_COURSE_ADD",
                    id: 10114,
                    name: "新增类目",
                    code: "SYSTEM_SHOP-MANAGE_COURSE_ADD",
                    sort: 1,
                  },
                  {
                    key: "SHOP_MANAGE_COURSE_EDIT",
                    id: 10115,
                    name: "编辑类目",
                    code: "SYSTEM_SHOP-MANAGE_COURSE_EDIT",
                    sort: 2,
                  },
                  {
                    key: "SHOP_MANAGE_COURSE_DELETE",
                    id: 10116,
                    name: "删除类目",
                    code: "SYSTEM_SHOP-MANAGE_COURSE_DELETE",
                    sort: 3,
                  }
                ],
              }
            ],
          },
          {
            key: "SHOP_MANAGE_SHOP_PLACE",
            id: 10103,
            name: "场地管理",
            code: "SYSTEM_SHOP-MANAGE_PLACE",
            sort: 3,
            children: [
              {
                key: "SHOP_MANAGE_PLACE_ADD",
                id: 10110,
                name: "新增",
                code: "SYSTEM_SHOP-MANAGE_PLACE_ADD",
                sort: 1,
              },
              {
                key: "SHOP_MANAGE_PLACE_EDIT",
                id: 10111,
                name: "编辑",
                code: "SYSTEM_SHOP-MANAGE_PLACE_EDIT",
                sort: 2,
              },
              {
                key: "SHOP_MANAGE_PLACE_DELETE",
                id: 10112,
                name: "删除",
                code: "SYSTEM_SHOP-MANAGE_PLACE_DELETE",
                sort: 3,
              }
            ],
          }
        ],
      },
      {
        key: "SHOP_MANAGE_COACH",
        id: 2,
        name: "教练管理",
        code: "SYSTEM_COACH-MANAGE",
        sort: 2,
        children: [
          {
            key: "COACH_MANAGE_ADD",
            id: 10201,
            name: "新增",
            code: "SYSTEM_COACH-MANAGE_ADD",
            sort: 1,
          },
          {
            key: "COACH_MANAGE_EDIT",
            id: 10202,
            name: "编辑",
            code: "SYSTEM_COACH-MANAGE_EDIT",
            sort: 2,
          },
          {
            key: "COACH_MANAGE_DELETE",
            id: 10203,
            name: "删除",
            code: "SYSTEM_COACH-MANAGE_DELETE",
            sort: 3,
          },
          {
            key: "COACH_MANAGE_SCHEDULE",
            id: 10204,
            name: "教练排课",
            code: "SYSTEM_COACH-MANAGE_SCHEDULE",
            sort: 4,
          },
          {
            key: "COACH_MANAGE_COPY",
            id: 10205,
            name: "复制教练",
            code: "SYSTEM_COACH-MANAGE_COPY",
            sort: 5,
          },
          {
            key: "COACH_MANAGE_EXPORT",
            id: 10206,
            name: "导出",
            code: "SYSTEM_COACH-MANAGE_EXPORT",
            sort: 6,
          }
        ],
      },
      {
        key: "SHOP_MANAGE_SALES",
        id: 9,
        name: "销售管理",
        code: "SYSTEM_SALES-MANAGE",
        sort: 3,
        children: [
          {
            key: "SALES_MANAGE_ORDER_AUDIT",
            id: 91,
            name: "销售审核",
            code: "SYSTEM_SALES-MANAGE_ORDER-AUDIT",
            sort: 1,
            children: [
              {
                key: "SALES_MANAGE_ORDER_AUDIT_AUDIT",
                id: 19101,
                name: "初审",
                code: "SYSTEM_SALES-MANAGE_ORDER-AUDIT_AUDIT",
                sort: 1,
              },
              {
                key: "SALES_MANAGE_ORDER_AUDIT_AUDIT_2",
                id: 19103,
                name: "二审",
                code: "SYSTEM_SALES-MANAGE_ORDER-AUDIT_AUDIT_2",
                sort: 1,
              },
              {
                key: "SALES_MANAGE_ORDER_AUDIT_DELETE",
                id: 19102,
                name: "删除",
                code: "SYSTEM_SALES-MANAGE_ORDER-AUDIT_DELETE",
                sort: 2,
              }
            ],
          },
          {
            key: "SALES_MANAGE_SALESMAN",
            id: 92,
            name: "销售员管理",
            code: "SYSTEM_SALES-MANAGE_SALESMAN-MANAGE",
            sort: 2,
            children: [
              {
                key: "SALES_MANAGE_SALESMAN_ADD",
                id: 19201,
                name: "新增",
                code: "SYSTEM_SALES-MANAGE_SALESMAN-MANAGE_ADD",
                sort: 1,
              },
              {
                key: "SALES_MANAGE_SALESMAN_EDIT",
                id: 19202,
                name: "编辑",
                code: "SYSTEM_SALES-MANAGE_SALESMAN-MANAGE_EDIT",
                sort: 2,
              },
              {
                key: "SALES_MANAGE_SALESMAN_COPY",
                id: 19203,
                name: "复制",
                code: "SYSTEM_SALES-MANAGE_SALESMAN-MANAGE_COPY",
                sort: 3,
              },
              {
                key: "SALES_MANAGE_SALESMAN_ALLOCATE",
                id: 19204,
                name: "分配学员",
                code: "SYSTEM_SALES-MANAGE_SALESMAN-MANAGE_ALLOCATE",
                sort: 4,
              },
              {
                key: "SALES_MANAGE_SALESMAN_DELETE",
                id: 19205,
                name: "删除",
                code: "SYSTEM_SALES-MANAGE_SALESMAN-MANAGE_DELETE",
                sort: 5,
              },
              {
                key: "SALES_MANAGE_SALES_RECORD",
                id: 19206,
                name: "销售记录",
                code: "SYSTEM_SALES-MANAGE_SALESMAN-MANAGE_SALES-RECORD",
                sort: 6,
              },
              {
                key: "SALES_MANAGE_SALESMAN_LEAVE",
                id: 19207,
                name: "离职",
                code: "SYSTEM_SALES-MANAGE_SALESMAN-MANAGE_LEAVE",
                sort: 7,
              }
            ],
          },
          {
            key: "SALES_MANAGE_COACH_CONVERSION_RATE",
            id: 10901,
            name: "教练转换率",
            code: "SYSTEM_SALES-MANAGE_COACH-CONVERSION-RATE",
            sort: 3,
          },
          {
            key: "SALES_MANAGE_GIFT_COURSE",
            id: 10902,
            name: "赠送记录",
            code: "SYSTEM_SALES-MANAGE_GIFT-COURSE",
            sort: 4,
            children: [
              {
                key: "SALES_MANAGE_GIFT_COURSE_EXPORT",
                id: 10903,
                name: "导出",
                code: "SYSTEM_SALES-MANAGE_GIFT-COURSE_EXPORT",
                sort: 1,
              }
            ],
          }
        ],
      },
      {
        key: "SHOP_MANAGE_TASK",
        id: 20,
        name: "任务中心",
        code: "SYSTEM_TASK-MANAGE",
        sort: 4,
        children: [
          {
            key: "TASK_MANAGE_TASK_TASK",
            id: 12001,
            name: "任务管理",
            code: "SYSTEM_TASK-MANAGE_LIST",
            sort: 1,
            children: [
              {
                key: "TASK_MANAGE_TASK_ADD",
                id: 12003,
                name: "添加",
                code: "SYSTEM_TASK-MANAGE_LIST_ADD",
                sort: 1,
              },
              {
                key: "TASK_MANAGE_TASK_EDIT",
                id: 12005,
                name: "编辑",
                code: "SYSTEM_TASK-MANAGE_LIST_EDIT",
                sort: 2,
              },
              {
                key: "TASK_MANAGE_TASK_STOP",
                id: 12006,
                name: "结束",
                code: "SYSTEM_TASK-MANAGE_LIST_STOP",
                sort: 3,
              }
            ],
          },
          {
            key: "TASK_MANAGE_TASK_AUDIT",
            id: 12002,
            name: "任务审核",
            code: "SYSTEM_TASK-MANAGE_AUDIT-LIST",
            sort: 2,
            children: [
              {
                key: "TASK_MANAGE_TASK_AUDIT_AUDIT",
                id: 12004,
                name: "审核",
                code: "SYSTEM_TASK-MANAGE_AUDIT-LIST_AUDIT",
                sort: 1,
              }
            ],
          }
        ],
      }
    ],
  },
  // 学员管理
  {
    key: "STUDENT_MANAGE",
    id: 10003,
    name: "学员管理",
    code: "STUDENT-MANAGE",
    sort: 3,
    children: [
      {
        key: "STUDENT_MANAGE_CENTER",
        id: 3,
        name: "学员中心",
        code: "SYSTEM_STUDENT-MANAGE",
        sort: 1,
        children: [
          {
            key: "STUDENT_MANAGE_ALL",
            id: 30,
            name: "全部用户",
            code: "SYSTEM_STUDENT-MANAGE_ALL",
            sort: 1,
            children: [
              {
                key: "STUDENT_MANAGE_SKILL",
                id: 31,
                name: "技能评级",
                code: "SYSTEM_STUDENT-MANAGE_SKILL",
                sort: 1,
              },
              {
                key: "STUDENT_MANAGE_EXPORT",
                id: 32,
                name: "导出",
                code: "SYSTEM_STUDENT-MANAGE_EXPORT",
                sort: 2,
                children: [
                  {
                    key: "STUDENT_MANAGE_EXPORT_1",
                    id: 13201,
                    name: "导出学员表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_1",
                    sort: 1,
                  },
                  {
                    key: "STUDENT_MANAGE_EXPORT_2",
                    id: 13202,
                    name: "导出充值表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_2",
                    sort: 1,
                  },
                  {
                    key: "STUDENT_MANAGE_EXPORT_3",
                    id: 13203,
                    name: "导出消课表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_3",
                    sort: 1,
                  },
                  {
                    key: "STUDENT_MANAGE_EXPORT_4",
                    id: 13204,
                    name: "导出过程数据表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_4",
                    sort: 1,
                  },
                  {
                    key: "STUDENT_MANAGE_EXPORT_5",
                    id: 13205,
                    name: "导出意向用户表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_5",
                    sort: 1,
                  },
                  {
                    key: "STUDENT_MANAGE_EXPORT_6",
                    id: 13206,
                    name: "导出邀约表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_6",
                    sort: 1,
                  },
                  {
                    key: "STUDENT_MANAGE_EXPORT_7",
                    id: 13207,
                    name: "导出消课分析表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_7",
                    sort: 1,
                  },
                  {
                    key: "STUDENT_MANAGE_EXPORT_8",
                    id: 13208,
                    name: "导出在籍学员表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_8",
                    sort: 1,
                  },
                  {
                    key: "STUDENT_MANAGE_EXPORT_9",
                    id: 13209,
                    name: "导出教练课程明细表",
                    code: "SYSTEM_STUDENT-MANAGE_EXPORT_9",
                    sort: 1,
                  }
                ],
              },
              {
                key: "STUDENT_MANAGE_LIGHT_ACHIEVEMENT",
                id: 33,
                name: "点亮成就",
                code: "SYSTEM_STUDENT-MANAGE_ACHIEVEMENT",
                sort: 3,
              },
              {
                key: "STUDENT_MANAGE_COURSE_RECORD_FEEDBACK",
                id: 34,
                name: "课程反馈",
                code: "SYSTEM_STUDENT-MANAGE_COURSE-RECORD-FEEDBACK",
                sort: 4,
              },
              {
                key: "STUDENT_MANAGE_ADD_REMARK",
                id: 35,
                name: "学员备注",
                code: "SYSTEM_STUDENT-MANAGE_ADD-REMARK",
                sort: 5,
              },
              {
                key: "STUDENT_MANAGE_ORDER",
                id: 36,
                name: "购买记录",
                code: "SYSTEM_STUDENT-MANAGE_ORDER",
                sort: 6,
              },
              {
                key: "STUDENT_MANAGE_ASSIGN_SALESMAN",
                id: 37,
                name: "设置销售员",
                code: "SYSTEM_STUDENT-MANAGE_ASSIGN-SALESMAN",
                sort: 7,
              },
              {
                key: "STUDENT_MANAGE_COURSE_RECORD",
                id: 38,
                name: "课程记录",
                code: "SYSTEM_STUDENT-MANAGE_COURSE-RECORD",
                sort: 8,
              },
              {
                key: "STUDENT_MANAGE_CHANGE_REMAINING_COURSE",
                id: 39,
                name: "消减课时",
                code: "SYSTEM_STUDENT-MANAGE_CHANGE-REMAINING-COURSE",
                sort: 9,
              },
              {
                key: "STUDENT_MANAGE_REDUCE_POINTS",
                id: 40,
                name: "扣减积分",
                code: "SYSTEM_STUDENT-MANAGE_REDUCE-POINTS",
                sort: 10,
              },
              {
                key: "STUDENT_MANAGE_POINTS_DETAIL",
                id: 41,
                name: "积分详情",
                code: "SYSTEM_STUDENT-MANAGE_POINTS-DETAIL",
                sort: 11,
              },
              {
                key: "STUDENT_MANAGE_EDIT_EXPIRE_TIME",
                id: 42,
                name: "编辑有效期",
                code: "SYSTEM_STUDENT-MANAGE_EDIT-EXPIRE-TIME",
                sort: 12,
              }
              ,
              {
                key: "STUDENT_MANAGE_OPEN_MEMBER_CARD",
                id: 301,
                name: "开卡",
                code: "SYSTEM_STUDENT-MANAGE_OPEN-MEMBER-CARD",
                sort: 13,
              }
            ],
          },
          {
            key: "STUDENT_MANAGE_MEMBER",
            id: 43,
            name: "开卡学员",
            code: "SYSTEM_STUDENT-MANAGE_MEMBER",
            sort: 2,
          },
          {
            key: "STUDENT_MANAGE_NOT_MEMBER",
            id: 44,
            name: "未开卡用户",
            code: "SYSTEM_STUDENT-MANAGE_NOT-MEMBER",
            sort: 2,
          },
          {
            key: "STUDENT_MANAGE_POTENTIAL_USER",
            id: 45,
            name: "意向学员",
            code: "SYSTEM_STUDENT-MANAGE_POTENTIAL-USER",
            sort: 2,
            children: [
              {
                key: "STUDENT_MANAGE_POTENTIAL_USER_ADD_RECORD",
                id: 14501,
                name: "添加记录",
                code: "SYSTEM_STUDENT-MANAGE_POTENTIAL-USER_ADD-RECORD",
                sort: 1,
              },
              {
                key: "STUDENT_MANAGE_POTENTIAL_USER_ADD_TRAIL_COURSE",
                id: 14502,
                name: "添加体验课",
                code: "SYSTEM_STUDENT-MANAGE_POTENTIAL-USER_ADD-TRAIL-COURSE",
                sort: 2,
              }
            ],
          }
        ],
      },
      {
        key: "STUDENT_MANAGE_FEEDBACK",
        id: 4,
        name: "学员反馈",
        code: "SYSTEM_FEEDBACK-MANAGE",
        sort: 2,
      },
      {
        key: "STUDENT_MANAGE_ACHIEVEMENT",
        id: 19,
        name: "成就中心",
        code: "SYSTEM_ACHIEVEMENT-MANAGE",
        sort: 3,
        children: [
          {
            key: "ACHIEVEMENT_MANAGE_ADD",
            id: 19001,
            name: "添加",
            code: "SYSTEM_ACHIEVEMENT-MANAGE_ADD",
            sort: 1,
          },
          {
            key: "ACHIEVEMENT_MANAGE_EDIT",
            id: 19002,
            name: "编辑",
            code: "SYSTEM_ACHIEVEMENT-MANAGE_EDIT",
            sort: 2,
          },
          {
            key: "ACHIEVEMENT_MANAGE_DELETE",
            id: 19003,
            name: "删除",
            code: "SYSTEM_ACHIEVEMENT-MANAGE_DELETE",
            sort: 3,
          },
          {
            key: "ACHIEVEMENT_MANAGE_CATEGORY_ADD",
            id: 19004,
            name: "分类添加",
            code: "SYSTEM_ACHIEVEMENT-MANAGE_CATEGORY_ADD",
            sort: 4,
          },
          {
            key: "ACHIEVEMENT_MANAGE_CATEGORY_EDIT",
            id: 19005,
            name: "分类编辑",
            code: "SYSTEM_ACHIEVEMENT-MANAGE_CATEGORY_EDIT",
            sort: 5,
          },
          {
            key: "ACHIEVEMENT_MANAGE_CATEGORY_DELETE",
            id: 19006,
            name: "分类删除",
            code: "SYSTEM_ACHIEVEMENT-MANAGE_CATEGORY_DELETE",
            sort: 6,
          }
        ],
      },
      {
        key: "STUDENT_MANAGE_POINTS",
        id: 21,
        name: "积分中心",
        code: "SYSTEM_POINTS-CENTER",
        sort: 4,
        children: [
          {
            key: "SYSTEM_POINTS_CENTER_SOURCE",
            id: 21001,
            name: "积分来源",
            code: "SYSTEM_POINTS-CENTER_SOURCE",
            sort: 1,
            children: [
              {
                key: "SYSTEM_POINTS_CENTER_SOURCE_EDIT",
                id: 2100101,
                name: "编辑",
                code: "SYSTEM_POINTS-CENTER_SOURCE_EDIT",
                sort: 1,
              },
              {
                key: "SYSTEM_POINTS_CENTER_SOURCE_DELETE",
                id: 2100102,
                name: "删除",
                code: "SYSTEM_POINTS-CENTER_SOURCE_DELETE",
                sort: 2,
              }
            ],
          },
          {
            key: "SYSTEM_POINTS_CENTER_MALL",
            id: 21002,
            name: "积分商城",
            code: "SYSTEM_POINTS-CENTER_MALL",
            sort: 2,
            children: [
              {
                key: "SYSTEM_POINTS_CENTER_MALL_EDIT",
                id: 2100201,
                name: "编辑",
                code: "SYSTEM_POINTS-CENTER_MALL_EDIT",
                sort: 1,
              },
              {
                key: "SYSTEM_POINTS_CENTER_MALL_DELETE",
                id: 2100202,
                name: "删除",
                code: "SYSTEM_POINTS-CENTER_MALL_DELETE",
                sort: 2,
              },
              {
                key: "SYSTEM_POINTS_CENTER_MALL_ADD",
                id: 2100203,
                name: "新增权益",
                code: "SYSTEM_POINTS-CENTER_MALL_ADD",
                sort: 3,
              }
            ],
          },
          {
            key: "SYSTEM_POINTS_CENTER_DETAIL",
            id: 21003,
            name: "积分明细",
            code: "SYSTEM_POINTS-CENTER_DETAIL",
            sort: 3,
            children: [
              {
                key: "SYSTEM_POINTS_CENTER_DETAIL_ADJUST_POINTS",
                id: 2100301,
                name: "人工调整积分",
                code: "SYSTEM_POINTS-CENTER_DETAIL_ADJUST_POINTS",
                sort: 1,
              },
              {
                key: "SYSTEM_POINTS_CENTER_DETAIL_EXPORT",
                id: 2100302,
                name: "导出",
                code: "SYSTEM_POINTS-CENTER_DETAIL_EXPORT",
                sort: 2,
              }
            ],
          }
        ],
      }
    ],
  },
  // 产品管理
  {
    key: "PRODUCT_MANAGE",
    id: 10004,
    name: "产品管理",
    code: "PRODUCT-MANAGE",
    sort: 4,
    children: [
      {
        key: "PRODUCT_MANAGE_PRODUCT",
        id: 11,
        name: "产品管理",
        code: "SYSTEM_PRODUCT-MANAGE",
        sort: 1,
        children: [
          {
            key: "PRODUCT_MANAGE_GOODS",
            id: 111,
            name: "总仓产品管理",
            code: "SYSTEM_PRODUCT-MANAGE_GOODS",
            sort: 1,
            children: [
              {
                key: "PRODUCT_MANAGE_GOODS_ADD",
                id: 11101,
                name: "新增产品",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_ADD",
                sort: 1,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_STOCK_IN",
                id: 11102,
                name: "产品入库记录",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_STOCK-IN",
                sort: 2,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_STOCK_ALLOCATE",
                id: 11103,
                name: "门店配货记录",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_STOCK-ALLOCATE",
                sort: 3,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_IMPORT",
                id: 11104,
                name: "批量导入",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_IMPORT",
                sort: 4,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_SHOP_GOODS_SALES",
                id: 11105,
                name: "自营产品销量记录",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_SHOP-GOODS-SALES",
                sort: 5,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_STOCK_OUT",
                id: 11106,
                name: "出库记录",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_STOCK-OUT",
                sort: 6,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_EDIT",
                id: 11112,
                name: "编辑",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_EDIT",
                sort: 7,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_EXPORT",
                id: 11107,
                name: "导出",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_EXPORT",
                sort: 8,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_SALES_RANKING",
                id: 11108,
                name: "销售排行",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_SALES-RANKING",
                sort: 9,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_STOCK",
                id: 11109,
                name: "库存管理",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_STOCK",
                sort: 10,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_SHOP_ALLOCATE",
                id: 11110,
                name: "门店配货",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_SHOP-ALLOCATE",
                sort: 11,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_DELETE",
                id: 11111,
                name: "删除",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS_DELETE",
                sort: 12,
              }
            ],
          },
          {
            key: "PRODUCT_MANAGE_SHOP_GOODS",
            id: 112,
            name: "门店产品管理",
            code: "SYSTEM_PRODUCT-MANAGE_SHOP-GOODS",
            sort: 2,
            children: [
              {
                key: "PRODUCT_MANAGE_SHOP_GOODS_SHOP_ALLOCATE",
                id: 11201,
                name: "门店配货",
                code: "SYSTEM_PRODUCT-MANAGE_SHOP-GOODS_SHOP-ALLOCATE",
                sort: 1,
              },
              {
                key: "PRODUCT_MANAGE_SHOP_GOODS_SHOP_ALLOCATE_RECORD",
                id: 11202,
                name: "门店配货记录",
                code: "SYSTEM_PRODUCT-MANAGE_SHOP-GOODS_SHOP-ALLOCATE-RECORD",
                sort: 2,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_RETURN",
                id: 1121,
                name: "批量退货",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS-RETURN",
                sort: 3,
              }
            ],
          },
          {
            key: "PRODUCT_MANAGE_GOODS_APPLY",
            id: 113,
            name: "门店产品申请",
            code: "SYSTEM_PRODUCT-MANAGE_GOODS-APPLY",
            sort: 3,
            children: [
              {
                key: "PRODUCT_MANAGE_GOODS_APPLY_AUDIT",
                id: 11301,
                name: "审批",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS-APPLY_AUDIT",
                sort: 1,
              }
            ],
          },
          {
            key: "PRODUCT_MANAGE_GOODS_CATALOG",
            id: 114,
            name: "产品自定义目录",
            code: "SYSTEM_PRODUCT-MANAGE_GOODS-CATALOG",
            sort: 4,
            children: [
              {
                key: "PRODUCT_MANAGE_GOODS_CATALOG_ADD",
                id: 11401,
                name: "新增目录",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS-CATALOG_ADD",
                sort: 1,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_CATALOG_SET",
                id: 11402,
                name: "陈列产品",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS-CATALOG_SET",
                sort: 2,
              },
              {
                key: "PRODUCT_MANAGE_GOODS_CATALOG_CHECK",
                id: 11403,
                name: "库存盘点",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS-CATALOG_CHECK",
                sort: 3,
              }
            ],
          },
          {
            key: "PRODUCT_MANAGE_GOODS_CHECK",
            id: 115,
            name: "盘点审核",
            code: "SYSTEM_PRODUCT-MANAGE_GOODS-CHECK",
            sort: 5,
            children: [
              {
                key: "PRODUCT_MANAGE_GOODS_CHECK_AUDIT",
                id: 11501,
                name: "审核",
                code: "SYSTEM_PRODUCT-MANAGE_GOODS-CHECK_AUDIT",
                sort: 1,
              }
            ],
          }
        ],
      },
      {
        key: "PRODUCT_MANAGE_DISCOUNT",
        id: 15,
        name: "折扣管理",
        code: "SYSTEM_DISCOUNT-MANAGE",
        sort: 2,
        children: [
          {
            key: "DISCOUNT_MANAGE_ADD",
            id: 15001,
            name: "新增折扣",
            code: "SYSTEM_DISCOUNT-MANAGE_ADD",
            sort: 1,
          },
          {
            key: "DISCOUNT_MANAGE_EDIT",
            id: 15002,
            name: "编辑",
            code: "SYSTEM_DISCOUNT-MANAGE_EDIT",
            sort: 2,
          },
          {
            key: "DISCOUNT_MANAGE_DELETE",
            id: 15003,
            name: "删除",
            code: "SYSTEM_DISCOUNT-MANAGE_DELETE",
            sort: 3,
          }
        ],
      }
    ],
  },
  // 社区管理
  {
    key: "COMMUNITY_MANAGE",
    id: 10005,
    name: "社区管理",
    code: "COMMUNITY-MANAGE",
    sort: 5,
    children: [
      {
        key: "COMMUNITY_MANAGE_COMMUNITY",
        id: 16,
        name: "社区管理",
        code: "SYSTEM_COMMUNITY-MANAGE",
        sort: 1,
        children: [
          {
            key: "COMMUNITY_MANAGE_OWNER",
            id: 16001,
            name: "主理人审核",
            code: "SYSTEM_COMMUNITY-MANAGE_OWNER",
            sort: 1,
          },
          {
            key: "COMMUNITY_MANAGE_COMMUNITY_AUDIT",
            id: 16002,
            name: "圈子审核",
            code: "SYSTEM_COMMUNITY-MANAGE_COMMUNITY",
            sort: 2,
          },
          {
            key: "COMMUNITY_MANAGE_ACTIVITY_AUDIT",
            id: 16003,
            name: "活动审核",
            code: "SYSTEM_COMMUNITY-MANAGE_ACTIVITY",
            sort: 3,
          },
          {
            key: "COMMUNITY_MANAGE_PUBLISHER",
            id: 16004,
            name: "媒体人审核",
            code: "SYSTEM_COMMUNITY-MANAGE_PUBLISHER",
            sort: 4,
          },
          {
            key: "COMMUNITY_MANAGE_NEWS",
            id: 16005,
            name: "新闻审核",
            code: "SYSTEM_COMMUNITY-MANAGE_NEWS",
            sort: 5,
          },
          // {
          //   key: "COMMUNITY_MANAGE_REFUND_AUDIT",
          //   id: 16006,
          //   name: "退款审核",
          //   code: "SYSTEM_COMMUNITY-MANAGE_REFUND-AUDIT",
          //   sort: 6,
          //   children: [
          //     {
          //       key: "COMMUNITY_MANAGE_REFUND_AUDIT_DETAIL",
          //       id: 1600601,
          //       name: "详情",
          //       code: "SYSTEM_COMMUNITY-MANAGE_REFUND-AUDIT_DETAIL",
          //       sort: 1,
          //     },
          //     {
          //       key: "COMMUNITY_MANAGE_REFUND_AUDIT_AUDIT",
          //       id: 1600602,
          //       name: "审核",
          //       code: "SYSTEM_COMMUNITY-MANAGE_REFUND-AUDIT_AUDIT",
          //       sort: 2,
          //     }
          //   ],
          // }
        ],
      },
      {
        key: "COMMUNITY_MANAGE_ACTIVITY",
        id: 5,
        name: "活动设置",
        code: "SYSTEM_ACTIVITY-MANAGE",
        sort: 2,
      },
      {
        key: "COMMUNITY_MANAGE_TAG",
        id: 17,
        name: "标签管理",
        code: "SYSTEM_TAG-MANAGE",
        sort: 3,
      }
    ],
  },
  // 课程管理
  {
    key: "COURSE_MANAGE",
    id: 10006,
    name: "课程管理",
    code: "COURSE-MANAGE",
    sort: 6,
    children: [
      {
        key: "COURSE_MANAGE_RECORD",
        id: 8,
        name: "课程记录管理",
        code: "SYSTEM_COURSE-MANAGE",
        sort: 1,
        children: [
          {
            key: "COURSE_MANAGE_COURSE_RECORD",
            id: 10801,
            name: "课程记录",
            code: "SYSTEM_COURSE-MANAGE_COURSE-RECORD",
            sort: 1,
            children: [
              {
                key: "COURSE_MANAGE_COURSE_RECORD_CANCEL",
                id: 10804,
                name: "退课",
                code: "SYSTEM_COURSE-MANAGE_COURSE-RECORD_CANCEL",
                sort: 1,
              },
              {
                key: "COURSE_MANAGE_COURSE_RECORD_CHECK_IN",
                id: 10805,
                name: "签到",
                code: "SYSTEM_COURSE-MANAGE_COURSE-RECORD_CHECK-IN",
                sort: 1,
              }
            ],
          },
          {
            key: "COURSE_MANAGE_COURSE_USED_RECORD",
            id: 10802,
            name: "消课记录",
            code: "SYSTEM_COURSE-MANAGE_COURSE-USED-RECORD",
            sort: 2,
            children: [
              {
                key: "COURSE_MANAGE_COURSE_USED_RECORD_EXPORT",
                id: 10806,
                name: "导出",
                code: "SYSTEM_COURSE-MANAGE_COURSE-USED-RECORD_EXPORT",
                sort: 1,
              }
            ],
          },
          {
            key: "COURSE_MANAGE_TRAIL_COURSE_RECORD",
            id: 10803,
            name: "体验课记录",
            code: "SYSTEM_COURSE-MANAGE_TRAIL-COURSE-RECORD",
            sort: 3,
            children: [
              {
                key: "COURSE_MANAGE_TRAIL_COURSE_RECORD_ADD",
                id: 10807,
                name: "新增",
                code: "SYSTEM_COURSE-MANAGE_TRAIL-COURSE-RECORD_ADD",
                sort: 1,
              },
              {
                key: "COURSE_MANAGE_TRAIL_COURSE_RECORD_EXPORT",
                id: 10808,
                name: "导出",
                code: "SYSTEM_COURSE-MANAGE_TRAIL-COURSE-RECORD_EXPORT",
                sort: 2,
              },
              {
                key: "COURSE_MANAGE_TRAIL_COURSE_RECORD_DELETE",
                id: 10809,
                name: "删除",
                code: "SYSTEM_COURSE-MANAGE_TRAIL-COURSE-RECORD_DELETE",
                sort: 3,
              }
              ,
              {
                key: "COURSE_SCHEDULE_MANAGE_TRAIN_CAMP_CONFIRM",
                id: 12306,
                name: "确认课表",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_TRAIN-CAMP_CONFIRM",
                sort: 4,
              }
            ],
          },
          {
            key: "COURSE_MANAGE_COURSE_AUDIT",
            id: 10810,
            name: "退补审核",
            code: "SYSTEM_COURSE-MANAGE_COURSE-AUDIT",
            sort: 4,
            children: [
              {
                key: "COURSE_MANAGE_COURSE_AUDIT_DETAIL",
                id: 10811,
                name: "详情",
                code: "SYSTEM_COURSE-MANAGE_COURSE-AUDIT_DETAIL",
                sort: 1,
              },
              {
                key: "COURSE_MANAGE_COURSE_AUDIT_AUDIT",
                id: 10812,
                name: "审核",
                code: "SYSTEM_COURSE-MANAGE_COURSE-AUDIT_AUDIT",
                sort: 2,
              }
            ],
          }
        ],
      },
      {
        key: "COURSE_MANAGE_SCHEDULE",
        id: 12,
        name: "课程表管理",
        code: "SYSTEM_COURSE-SCHEDULE-MANAGE",
        sort: 2,
        children: [
          {
            key: "COURSE_SCHEDULE_MANAGE_SCHEDULE",
            id: 121,
            name: "课程表管理",
            code: "SYSTEM_COURSE-SCHEDULE-MANAGE_SCHEDULE",
            sort: 1,
          },
          {
            key: "COURSE_SCHEDULE_MANAGE_CLASS",
            id: 122,
            name: "班级管理",
            code: "SYSTEM_COURSE-SCHEDULE-MANAGE_CLASS",
            sort: 2,
            children: [
              {
                key: "COURSE_SCHEDULE_MANAGE_CLASS_ADD",
                id: 12201,
                name: "添加",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_CLASS_ADD",
                sort: 1,
              },
              {
                key: "COURSE_SCHEDULE_MANAGE_CLASS_EDIT",
                id: 12202,
                name: "编辑",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_CLASS_EDIT",
                sort: 2,
              },
              {
                key: "COURSE_SCHEDULE_MANAGE_CLASS_DELETE",
                id: 12203,
                name: "删除",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_CLASS_DELETE",
                sort: 3,
              },
              {
                key: "COURSE_SCHEDULE_MANAGE_CLASS_SET_STUDENT",
                id: 12204,
                name: "学员管理",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_CLASS_SET-STUDENT",
                sort: 4,
              },
              {
                key: "COURSE_SCHEDULE_MANAGE_CLASS_SCHEDULE",
                id: 12205,
                name: "立即排课",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_CLASS_SCHEDULE",
                sort: 5,
              }
            ],
          },
          {
            key: "SYSTEM_COURSE_SCHEDULE_MANAGE_TRAIN_CAMP",
            id: 123,
            name: "集训课管理",
            code: "SYSTEM_COURSE-SCHEDULE-MANAGE_TRAIN-CAMP",
            sort: 3,
            children: [
              {
                key: "SYSTEM_COURSE_SCHEDULE_MANAGE_TRAIN_CAMP_ADD",
                id: 12301,
                name: "新增班级",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_TRAIN-CAMP_ADD",
                sort: 1,
              },
              {
                key: "SYSTEM_COURSE_SCHEDULE_MANAGE_TRAIN_CAMP_EDIT",
                id: 12302,
                name: "编辑",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_TRAIN-CAMP_EDIT",
                sort: 2,
              },
              {
                key: "SYSTEM_COURSE_SCHEDULE_MANAGE_TRAIN_CAMP_DELETE",
                id: 12303,
                name: "删除",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_TRAIN-CAMP_DELETE",
                sort: 3,
              },
              {
                key: "SYSTEM_COURSE_SCHEDULE_MANAGE_TRAIN_CAMP_SET_STUDENT",
                id: 12304,
                name: "学员管理",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_TRAIN-CAMP_SET-STUDENT",
                sort: 4,
              },
              {
                key: "SYSTEM_COURSE_SCHEDULE_MANAGE_TRAIN_CAMP_SCHEDULE",
                id: 12305,
                name: "立即排课",
                code: "SYSTEM_COURSE-SCHEDULE-MANAGE_TRAIN-CAMP_SCHEDULE",
                sort: 5,
              }
            ],
          }
        ],
      }
    ],
  },
  // 票务管理
  {
    key: "TICKET_MANAGE",
    id: 10007,
    name: "票务管理",
    code: "TICKET-MANAGE",
    sort: 7,
    children: [
      {
        key: "TICKET_MANAGE_BUY_RECORD",
        id: 11801,
        name: "购买记录",
        code: "SYSTEM_TICKET-MANAGE_BUG_RECORD",
        sort: 1,
      },
      {
        key: "TICKET_MANAGE_SALES_RECORD",
        id: 11802,
        name: "销售记录",
        code: "SYSTEM_TICKET-MANAGE_SALES_RECORD",
        sort: 2,
      },
      {
        key: "TICKET_MANAGE_CATEGORY",
        id: 11803,
        name: "门票类别",
        code: "SYSTEM_TICKET-MANAGE_CATEGORY",
        sort: 3,
        children: [
          {
            key: "TICKET_MANAGE_CATEGORY_ADD",
            id: 1180301,
            name: "新增",
            code: "SYSTEM_TICKET-MANAGE_CATEGORY_ADD",
            sort: 1,
          },
          {
            key: "TICKET_MANAGE_CATEGORY_EDIT",
            id: 1180302,
            name: "编辑",
            code: "SYSTEM_TICKET-MANAGE_CATEGORY_EDIT",
            sort: 2,
          },
          {
            key: "TICKET_MANAGE_CATEGORY_DELETE",
            id: 1180303,
            name: "删除",
            code: "SYSTEM_TICKET-MANAGE_CATEGORY_DELETE",
            sort: 3,
          }
        ],
      }
    ],
  },
  // 第三方配置
  {
    key: "THIRD_CONFIG",
    id: 10008,
    name: "第三方配置",
    code: "THIRD-CONFIG",
    sort: 8,
    children: [
      {
        key: "THIRD_CONFIG_CONTRACT",
        id: 13,
        name: "合同管理",
        code: "SYSTEM_CONTRACT-MANAGE",
        sort: 1,
      },
      {
        key: "THIRD_CONFIG_TERMINAL",
        id: 14,
        name: "终端管理",
        code: "SYSTEM_TERMINAL-MANAGE",
        sort: 2,
      },
      {
        key: "THIRD_CONFIG_INSURANCE",
        id: 18,
        name: "保险管理",
        code: "SYSTEM_INSURANCE-MANAGE",
        sort: 3,
        children: [
          {
            key: "INSURANCE_MANAGE_INSURANCE_AUDIT_LIST",
            id: 18001,
            name: "保险审核",
            code: "SYSTEM_INSURANCE-MANAGE_INSURANCE-AUDIT-LIST",
            sort: 1,
            children: [
              {
                key: "INSURANCE_MANAGE_INSURANCE_AUDIT_LIST_STEP1",
                id: 18003,
                name: "初审",
                code: "SYSTEM_INSURANCE-MANAGE_INSURANCE-AUDIT-LIST_STEP1",
                sort: 1,
              },
              {
                key: "INSURANCE_MANAGE_INSURANCE_AUDIT_LIST_STEP2",
                id: 18004,
                name: "二审",
                code: "SYSTEM_INSURANCE-MANAGE_INSURANCE-AUDIT-LIST_STEP2",
                sort: 2,
              }
            ]
          },
          {
            key: "INSURANCE_MANAGE_INSURANCE_LIST",
            id: 18002,
            name: "保险单管理",
            code: "SYSTEM_INSURANCE-MANAGE_INSURANCE-LIST",
            sort: 2,
          }
        ],
      }
    ],
  },
  // 系统设置
  {
    key: "SYSTEM_CONFIG",
    id: 10009,
    name: "系统设置",
    code: "SYSTEM-CONFIG",
    sort: 9,
    children: [
      {
        key: "SYSTEM_CONFIG_ACCOUNT",
        id: 6,
        name: "账号管理",
        code: "SYSTEM_ACCOUNT-MANAGE",
        sort: 1,
        children: [
          {
            key: "ACCOUNT_MANAGE_ADD",
            id: 10601,
            name: "新增账号",
            code: "SYSTEM_ACCOUNT-MANAGE_ADD",
            sort: 1,
          },
          {
            key: "ACCOUNT_MANAGE_EDIT",
            id: 10602,
            name: "编辑",
            code: "SYSTEM_ACCOUNT-MANAGE_EDIT",
            sort: 2,
          },
          {
            key: "ACCOUNT_MANAGE_RESET_PASSWORD",
            id: 10603,
            name: "重置密码",
            code: "SYSTEM_ACCOUNT-MANAGE_RESET-PASSWORD",
            sort: 3,
          },
          {
            key: "ACCOUNT_MANAGE_DELETE",
            id: 10604,
            name: "删除",
            code: "SYSTEM_ACCOUNT-MANAGE_DELETE",
            sort: 4,
          }
        ],
      },
      {
        key: "SYSTEM_CONFIG_ROLE",
        id: 7,
        name: "角色管理",
        code: "SYSTEM_ROLE-MANAGE",
        sort: 2,
        children: [
          {
            key: "ROLE_MANAGE_ADD",
            id: 10701,
            name: "新增角色",
            code: "SYSTEM_ROLE-MANAGE_ADD",
            sort: 1,
          },
          {
            key: "ROLE_MANAGE_EDIT",
            id: 10702,
            name: "编辑",
            code: "SYSTEM_ROLE-MANAGE_EDIT",
            sort: 2,
          },
          {
            key: "ROLE_MANAGE_BIND_ACCOUNT",
            id: 10703,
            name: "关联账号",
            code: "SYSTEM_ROLE-MANAGE_BIND-ACCOUNT",
            sort: 3,
          },
          {
            key: "ROLE_MANAGE_DELETE",
            id: 10704,
            name: "删除",
            code: "SYSTEM_ROLE-MANAGE_DELETE",
            sort: 4,
          }
        ],
      }
    ],
  },
  // 考试管理
  {
    key: "EXAM_MANAGE",
    id: 10010,
    name: "考试管理",
    code: "EXAM-MANAGE",
    sort: 10,
    children: [
      {
        key: "EXAM_MANAGE_QUESTION",
        id: 51,
        name: "题目管理",
        code: "SYSTEM_EXAM-MANAGE_QUESTION",
        sort: 1,
      },
      {
        key: "EXAM_MANAGE_EXAM_CONFIG",
        id: 52,
        name: "考试配置",
        code: "SYSTEM_EXAM-MANAGE_CONFIG",
        sort: 2,
      },
      {
        key: "EXAM_MANAGE_SCORE_RECORD",
        id: 53,
        name: "成绩记录",
        code: "SYSTEM_EXAM-MANAGE_EXAM-RECORD",
        sort: 3,
      },
      {
        key: "EXAM_MANAGE_UNIFY_EXAM",
        id: 54,
        name: "专项考试",
        code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM",
        sort: 4,
        children: [
          {
            key: "EXAM_MANAGE_UNIFY_EXAM_MANAGE",
            id: 55,
            name: "专项考试管理",
            code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM-MANAGER",
            sort: 5,
            children: [
              {
                key: "EXAM_MANAGE_UNIFY_EXAM_MANAGE_ADD",
                id: 5501,
                name: "增加",
                code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM_ADD",
                sort: 1,
              },
              {
                key: "EXAM_MANAGE_UNIFY_EXAM_MANAGE_EDIT",
                id: 5502,
                name: "编辑",
                code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM_EDIT",
                sort: 2,
              },
              {
                key: "EXAM_MANAGE_UNIFY_EXAM_MANAGE_DETAIL",
                id: 5503,
                name: "详情",
                code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM_DETAIL",
                sort: 3,
              },
              {
                key: "EXAM_MANAGE_UNIFY_EXAM_MANAGE_DELETE",
                id: 5504,
                name: "删除",
                code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM_DELETE",
                sort: 4,
              },
              {
                key: "EXAM_MANAGE_UNIFY_EXAM_MANAGE_EXAM_CONFIG",
                id: 5505,
                name: "考试配置",
                code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM_EXAM-CONFIG",
                sort: 5,
              },
              {
                key: "EXAM_MANAGE_UNIFY_EXAM_MANAGE_EXAM_DETAIL",
                id: 5506,
                name: "考试详情",
                code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM_EXAM-DETAIL",
                sort: 6,
              },
              {
                key: "EXAM_MANAGE_UNIFY_EXAM_MANAGE_STATUS_UPDATE",
                id: 5507,
                name: "状态更新",
                code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM_STATUS-UPDATE",
                sort: 7,
              }
            ],
          },
          {
            key: "EXAM_MANAGE_UNIFY_EXAM_RESULT",
            id: 56,
            name: "专项考试成绩管理",
            code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM-RESULT",
            sort: 6,
            children: [
              {
                key: "EXAM_MANAGE_UNIFY_EXAM_RESULT_DETAIL",
                id: 5601,
                name: "详情",
                code: "SYSTEM_EXAM-MANAGE_UNIFY-EXAM-RESULT_DETAIL",
                sort: 1,
              }
            ],
          }
        ],
      }
    ],
  },
  // 规则管理
  {
    key: "RULE_MANAGE",
    id: 10011,
    name: "规则管理",
    code: "RULE-MANAGE",
    sort: 11,
    children: [
      {
        key: "RULE_MANAGE_COURSE_CONFIG",
        id: 61,
        name: "课程规则配置",
        code: "SYSTEM_RULE-MANAGE_COURSE-CONFIG",
        sort: 1,
        children: [
          {
            key: "RULE_MANAGE_COURSE_CONFIG_EDIT",
            id: 16101,
            name: "编辑",
            code: "SYSTEM_RULE-MANAGE_COURSE-CONFIG_EDIT",
            sort: 1,
          }
        ],
      },
      {
        key: "RULE_MANAGE_NOTICE_CONFIG",
        id: 62,
        name: "系统推送规则配置",
        code: "SYSTEM_RULE-MANAGE_NOTICE-CONFIG",
        sort: 2,
        children: [
          {
            key: "RULE_MANAGE_NOTICE_CONFIG_EDIT",
            id: 16102,
            name: "编辑",
            code: "SYSTEM_RULE-MANAGE_NOTICE-CONFIG_EDIT",
            sort: 1,
          }
        ],
      },
      {
        key: "RULE_MANAGE_AUDIT_FLOW_CONFIG",
        id: 63,
        name: "系统审核流程配置",
        code: "SYSTEM_RULE-MANAGE_AUDIT-FLOW-CONFIG",
        sort: 3,
        children: [
          {
            key: "RULE_MANAGE_AUDIT_FLOW_CONFIG_EDIT",
            id: 16103,
            name: "编辑",
            code: "SYSTEM_RULE-MANAGE_AUDIT-FLOW-CONFIG_EDIT",
            sort: 1,
          },
          {
            key: "RULE_MANAGE_AUDIT_FLOW_CONFIG_ADD",
            id: 16104,
            name: "添加",
            code: "SYSTEM_RULE-MANAGE_AUDIT-FLOW-CONFIG_ADD",
            sort: 2,
          },
          {
            key: "RULE_MANAGE_AUDIT_FLOW_CONFIG_DELETE",
            id: 16105,
            name: "删除",
            code: "SYSTEM_RULE-MANAGE_AUDIT-FLOW-CONFIG_DELETE",
            sort: 3,
          },
          {
            key: "RULE_MANAGE_AUDIT_FLOW_CONFIG_DETAIL",
            id: 16106,
            name: "详情",
            code: "SYSTEM_RULE-MANAGE_AUDIT-FLOW-CONFIG_DETAIL",
            sort: 4,
          },
          {
            key: "RULE_MANAGE_AUDIT_FLOW_CONFIG_ENABLE",
            id: 16107,
            name: "启用",
            code: "SYSTEM_RULE-MANAGE_AUDIT-FLOW-CONFIG_ENABLE",
            sort: 5,
          }

        ],
      }
    ],
  },
  // 结算管理
  {
    key: "SETTLE_MANAGE",
    id: 10012,
    name: "结算管理",
    code: "SETTLE-MANAGE",
    sort: 12,
    children: [
      {
        key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_CONFIG",
        id: 22001,
        name: "装备结算配置",
        code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-CONFIG",
        sort: 1,
        children: [
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_CONFIG_ADD",
            id: 2200101,
            name: "新增",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-CONFIG_ADD",
            sort: 1,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_CONFIG_DETAIL",
            id: 2200102,
            name: "详情",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-CONFIG_DETAIL",
            sort: 2,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_CONFIG_EDIT",
            id: 2200103,
            name: "编辑",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-CONFIG_EDIT",
            sort: 3,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_CONFIG_ENABLE",
            id: 2200104,
            name: "启用",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-CONFIG_ENABLE",
            sort: 4,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_CONFIG_DELETE",
            id: 2200105,
            name: "删除",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-CONFIG_DELETE",
            sort: 5,
          }
        ],
      },
      {
        key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST",
        id: 22002,
        name: "装备结算列表",
        code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-LIST",
        sort: 2,
        children: [
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST_ADD",
            id: 2200201,
            name: "新增",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-LIST_ADD",
            sort: 1,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST_DETAIL",
            id: 2200202,
            name: "详情",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-LIST_DETAIL",
            sort: 2,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST_EXPORT",
            id: 2200203,
            name: "导出",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-LIST_EXPORT",
            sort: 3,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST_REGENERATE",
            id: 2200204,
            name: "重新生成",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-LIST_REGENERATE",
            sort: 4,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST_CONFIRM",
            id: 2200205,
            name: "确认",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-LIST_CONFIRM",
            sort: 5,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_EQUIPMENT_LIST_DELETE",
            id: 2200206,
            name: "删除",
            code: "SYSTEM_SETTLE-MANAGE_EQUIPMENT-LIST_DELETE",
            sort: 6,
          }
        ],
      },
      {
        key: "SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY",
        id: 22003,
        name: "教练消课汇总",
        code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-SUMMARY",
        sort: 3,
        children: [
          {
            key: "SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY_ADD",
            id: 2200301,
            name: "新增",
            code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-SUMMARY_ADD",
            sort: 1,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY_DETAIL",
            id: 2200302,
            name: "详情",
            code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-SUMMARY_DETAIL",
            sort: 2,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY_EXPORT",
            id: 2200303,
            name: "导出",
            code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-SUMMARY_EXPORT",
            sort: 3,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY_REGENERATE",
            id: 2200304,
            name: "重新生成",
            code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-SUMMARY_REGENERATE",
            sort: 4,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY_CONFIRM",
            id: 2200305,
            name: "确认",
            code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-SUMMARY_CONFIRM",
            sort: 5,
          },
          {
            key: "SYSTEM_SETTLE_MANAGE_COACH_CONSUME_SUMMARY_DELETE",
            id: 2200306,
            name: "删除",
            code: "SYSTEM_SETTLE-MANAGE_COACH-CONSUME-SUMMARY_DELETE",
            sort: 6,
          }
        ],
      }
    ],
  },
  // 功能管理
  {
    key: "FUNCTION_MANAGE",
    id: 10013,
    name: "功能管理",
    code: "FUNCTION-MANAGE",
    sort: 13,
    children: [
      {
        key: "SYSTEM_FUNCTION_MANAGE_FEE_CONFIG",
        id: 71,
        name: "功能费用配置",
        code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG",
        sort: 1,
        children: [
          {
            key: "SYSTEM_FUNCTION_MANAGE_FEE_CONFIG_ADD",
            id: 17101,
            name: "新增",
            code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG_ADD",
            sort: 1,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_FEE_CONFIG_GIFT",
            id: 17102,
            name: "赠送",
            code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG_GIFT",
            sort: 2,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_FEE_CONFIG_DETAIL",
            id: 17103,
            name: "详情",
            code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG_DETAIL",
            sort: 3,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_FEE_CONFIG_EDIT",
            id: 17104,
            name: "编辑",
            code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG_EDIT",
            sort: 4,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_FEE_CONFIG_PERMISSION_EDIT",
            id: 17105,
            name: "权限编辑",
            code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG_PERMISSION-EDIT",
            sort: 5,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_FEE_CONFIG_PACKAGE_SET",
            id: 17106,
            name: "套餐设置",
            code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG_PACKAGE-SET",
            sort: 6,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_FEE_CONFIG_DISABLE",
            id: 17107,
            name: "停用",
            code: "SYSTEM_FUNCTION-MANAGE_FEE-CONFIG_DISABLE",
            sort: 7,
          }
        ],
      },
      {
        key: "SYSTEM_FUNCTION_MANAGE_PAID_ORDER",
        id: 72,
        name: "付费功能订单",
        code: "SYSTEM_FUNCTION-MANAGE_PAID-ORDER",
        sort: 2,
        children: [
          {
            key: "SYSTEM_FUNCTION_MANAGE_PAID_ORDER_EXPORT",
            id: 17201,
            name: "导出",
            code: "SYSTEM_FUNCTION-MANAGE_PAID-ORDER_EXPORT",
            sort: 1,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_PAID_ORDER_DETAIL",
            id: 17202,
            name: "详情",
            code: "SYSTEM_FUNCTION-MANAGE_PAID-ORDER_DETAIL",
            sort: 2,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_PAID_ORDER_UPDATE_EXPIRE",
            id: 17203,
            name: "修改有效期",
            code: "SYSTEM_FUNCTION-MANAGE_PAID-ORDER_UPDATE-EXPIRE",
            sort: 3,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_PAID_ORDER_REFUND",
            id: 17204,
            name: "退款",
            code: "SYSTEM_FUNCTION-MANAGE_PAID-ORDER_REFUND",
            sort: 4,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_PAID_ORDER_ENABLE",
            id: 17205,
            name: "停用",
            code: "SYSTEM_FUNCTION-MANAGE_PAID-ORDER_ENABLE",
            sort: 5,
          }
        ],
      },
      {
        key: "SYSTEM_FUNCTION_MANAGE_PAID_REFUND",
        id: 73,
        name: "付费功能退款",
        code: "SYSTEM_FUNCTION-MANAGE_PAID-REFUND",
        sort: 3,
        children: [
          {
            key: "SYSTEM_FUNCTION_MANAGE_PAID_REFUND_DETAIL",
            id: 17301,
            name: "详情",
            code: "SYSTEM_FUNCTION-MANAGE_PAID-REFUND_DETAIL",
            sort: 1,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_PAID_REFUND_REVOKE",
            id: 17302,
            name: "撤销",
            code: "SYSTEM_FUNCTION-MANAGE_PAID-REFUND_REVOKE",
            sort: 2,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_PAID_REFUND_CONFIRM",
            id: 17303,
            name: "确认",
            code: "SYSTEM_FUNCTION-MANAGE_PAID-REFUND_CONFIRM",
            sort: 3,
          }
        ],
      },
      {
        key: "SYSTEM_FUNCTION_MANAGE_WHITELIST",
        id: 74,
        name: "白名单",
        code: "SYSTEM_FUNCTION-MANAGE_WHITELIST",
        sort: 4,
        children: [
          {
            key: "SYSTEM_FUNCTION_MANAGE_WHITELIST_ADD",
            id: 17401,
            name: "新增",
            code: "SYSTEM_FUNCTION-MANAGE_WHITELIST_ADD",
            sort: 1,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_WHITELIST_EDIT",
            id: 17402,
            name: "编辑",
            code: "SYSTEM_FUNCTION-MANAGE_WHITELIST_EDIT",
            sort: 2,
          },
          {
            key: "SYSTEM_FUNCTION_MANAGE_WHITELIST_DELETE",
            id: 17403,
            name: "删除",
            code: "SYSTEM_FUNCTION-MANAGE_WHITELIST_DELETE",
            sort: 3,
          }
        ],
      }
    ],
  },
  {
    key: "PARTNER_MANAGE",
    id: 10014,
    name: "合作方管理",
    code: "PARTNER-MANAGE",
    sort: 13,
    children: [
      {
        key: "PARTNER_MANAGE_TENANT_MANAGE",
        id: 23001,
        name: "商户管理",
        code: "PARTNER-MANAGE_TENANT-MANAGE",
        sort: 1,
        children: [
          {
            key: "PARTNER_MANAGE_TENANT_MANAGE_ADD",
            id: 2300101,
            name: "新增",
            code: "PARTNER-MANAGE_TENANT-MANAGE_ADD",
            sort: 1,
          },
          {
            key: "PARTNER_MANAGE_TENANT_MANAGE_EDIT",
            id: 2300102,
            name: "编辑",
            code: "PARTNER-MANAGE_TENANT-MANAGE_EDIT",
            sort: 2,
          },
          {
            key: "PARTNER_MANAGE_TENANT_MANAGE_DISABLE",
            id: 2300103,
            name: "停用",
            code: "PARTNER-MANAGE_TENANT-MANAGE_DISABLE",
            sort: 3,
          },
          {
            key: "PARTNER_MANAGE_TENANT_MANAGE_ADMIN_CONFIG",
            id: 2300104,
            name: "管理员配置",
            code: "PARTNER-MANAGE_TENANT-MANAGE_ADMIN-CONFIG",
            sort: 4,
          },
          {
            key: "PARTNER_MANAGE_TENANT_MANAGE_DELETE",
            id: 2300105,
            name: "删除",
            code: "PARTNER-MANAGE_TENANT-MANAGE_DELETE",
            sort: 5,
          }
        ],
      },
      {
        key: "PARTNER_MANAGE_TENANT_ROLE",
        id: 23002,
        name: "商户角色",
        code: "PARTNER-MANAGE_TENANT-ROLE",
        sort: 2,
        children: [
          {
            key: "PARTNER_MANAGE_TENANT_ROLE_ADD",
            id: 2300201,
            name: "新增",
            code: "PARTNER-MANAGE_TENANT-ROLE_ADD",
            sort: 1,
          },
          {
            key: "PARTNER_MANAGE_TENANT_ROLE_EDIT",
            id: 2300202,
            name: "编辑",
            code: "PARTNER-MANAGE_TENANT-ROLE_EDIT",
            sort: 2,
          },
          {
            key: "PARTNER_MANAGE_TENANT_ROLE_BIND_ACCOUNT",
            id: 2300203,
            name: "关联账号",
            code: "PARTNER-MANAGE_TENANT-ROLE_BIND-ACCOUNT",
            sort: 3,
          },
          {
            key: "PARTNER_MANAGE_TENANT_ROLE_DELETE",
            id: 2300204,
            name: "删除",
            code: "PARTNER-MANAGE_TENANT-ROLE_DELETE",
            sort: 4,
          }
        ],
      },
      {
        key: "PARTNER_MANAGE_SHOP_APPLY",
        id: 23003,
        name: "门店申请管理",
        code: "PARTNER-MANAGE_SHOP-APPLY",
        sort: 3,
        children: [
          {
            key: "PARTNER_MANAGE_SHOP_APPLY_DETAIL",
            id: 2300301,
            name: "详情",
            code: "PARTNER-MANAGE_SHOP-APPLY_DETAIL",
            sort: 1,
          },
          {
            key: "PARTNER_MANAGE_SHOP_APPLY_DELETE",
            id: 2300302,
            name: "删除",
            code: "PARTNER-MANAGE_SHOP-APPLY_DELETE",
            sort: 2,
          },
          {
            key: "PARTNER_MANAGE_SHOP_APPLY_EXPORT",
            id: 2300303,
            name: "导出",
            code: "PARTNER-MANAGE_SHOP-APPLY_EXPORT",
            sort: 3,
          }
        ],
      },
    ],
  }
];
